import ProgressBar from 'react-bootstrap/ProgressBar'

import {
  formatCurrency,
  formatSellThrough,
  getSellThroughStatusMeta,
} from './pricingLevelPerformanceUtils'

function barVariant(status) {
  if (status === 'good') return 'success'
  if (status === 'critical') return 'danger'
  return 'warning'
}

export default function PricingLevelRevenueOpportunity({ revenueOpportunity }) {
  const bars = revenueOpportunity?.bars || []
  const revenueRemaining = revenueOpportunity?.revenueRemaining || []

  if (!bars.length) {
    return (
      <p className="text-muted small mb-0">
        No revenue opportunity data available yet.
      </p>
    )
  }

  return (
    <div className="pricing-level-revenue-opportunity">
      <div className="pricing-level-opportunity-bars">
        {bars.map((row) => {
          const pct = Math.max(
            0,
            Math.min(100, Number(row.sellThroughPercentage || 0))
          )
          const meta = getSellThroughStatusMeta(row.status)

          return (
            <div
              key={row.name}
              className={`pricing-level-opportunity-bar-row pricing-level-opportunity-bar-row--${row.status}`}
            >
              <div className="pricing-level-opportunity-bar-label">
                <span className="pricing-level-opportunity-bar-name">
                  {row.name}
                </span>
                <span className="pricing-level-opportunity-bar-value">
                  <span aria-hidden>{meta.emoji}</span>{' '}
                  {formatSellThrough(row.sellThroughPercentage)}
                </span>
              </div>
              <ProgressBar
                now={pct}
                variant={barVariant(row.status)}
                className="pricing-level-opportunity-bar"
              />
            </div>
          )
        })}
      </div>

      {revenueRemaining.length > 0 && (
        <div className="pricing-level-revenue-remaining">
          <h3 className="pricing-level-revenue-remaining__title">
            Revenue Remaining
          </h3>
          <ul className="pricing-level-revenue-remaining__list list-unstyled mb-0">
            {revenueRemaining.map((row) => (
              <li
                key={row.name}
                className="pricing-level-revenue-remaining__row"
              >
                <span className="pricing-level-revenue-remaining__name">
                  {row.name}
                </span>
                <span className="pricing-level-revenue-remaining__amount">
                  {formatCurrency(row.amount)}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
